import { View } from "@react-pdf/renderer";
import React from "react";
import { tw } from "./tailwind";

/** Props Interface */
interface SpacerProps {
	fixed?: boolean;
}

export function Spacer({ fixed }: SpacerProps) {
	return (
		<React.Fragment>
			<View
				style={tw("h-8")}
				wrap
				fixed={fixed}
			/>
		</React.Fragment>
	);
}
